// extracted by mini-css-extract-plugin
export default {"csPage":"CustomerService_csPage__YaH25","wrapper":"CustomerService_wrapper__M4n-l","mainContent":"CustomerService_mainContent__bgFjb"};